import React from "react";

interface Props {
  size?: string;
  color?: string;
}
const RequiredIcon = ({ size = "20", color = "#79808A" }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 2.84961C10.2668 2.84961 10.4832 3.06622 10.4834 3.33301V8.67871L14.2891 4.87305C14.4909 4.67127 14.8199 4.67711 15.0146 4.88574C15.1997 5.08446 15.194 5.39386 15.002 5.58594L11.0713 9.5166H16.667C16.9338 9.51678 17.1504 9.73317 17.1504 10C17.1504 10.2668 16.9338 10.4832 16.667 10.4834H11.1553L15.0859 14.4141C15.2714 14.5995 15.2714 14.9005 15.0859 15.0859C14.9005 15.2714 14.5995 15.2714 14.4141 15.0859L10.4834 11.1553V16.667C10.4832 16.9338 10.2668 17.1504 10 17.1504C9.73317 17.1504 9.51678 16.9338 9.5166 16.667V11.0713L5.58887 14.999C5.40161 15.1863 5.09839 15.1863 4.91113 14.999C4.72543 14.8133 4.72363 14.513 4.90723 14.3252L8.08398 11.0781L8.66504 10.4834H3.33301C3.06622 10.4832 2.84961 10.2668 2.84961 10C2.84961 9.73317 3.06622 9.51678 3.33301 9.5166H8.84473L4.91406 5.58594C4.72858 5.40045 4.72858 5.09954 4.91406 4.91406C5.09954 4.72858 5.40045 4.72858 5.58594 4.91406L9.5166 8.84473V3.33301C9.51678 3.06622 9.73317 2.84961 10 2.84961Z"
        stroke={color}
        stroke-width="0.7"
      />
    </svg>
  );
};

export default RequiredIcon;
